import PropTypes from 'prop-types';
import './loadingPanel.scss';

const LoadingPanel = ({ isLoading, children }) => (
    isLoading ? <Loader /> : children
);

const Loader = () => (
    <div className="loading-container">
        <div className="loading-indicator">
            <span className="loading-bullet">•</span>
            <span className="loading-bullet">•</span>
            <span className="loading-bullet">•</span>
        </div>
    </div>
);

LoadingPanel.propTypes = {
    isLoading: PropTypes.bool.isRequired,
};

export default LoadingPanel;
